<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-text-field
        v-model="secret"
        label="Chave Secreta"
        required
        :rules="[(v) => secretRegex.test(v) || 'Chave Secreta inválida']"
        outlined
        placeholder="sk_A1B2C3D4E5"
        counter
        :maxlength="100"
        :disabled="loading"
      />
      <v-text-field
        v-model="publicKey"
        label="Chave Pública"
        placeholder="pk_A1B2C3D4E5"
        required
        type="tel"
        outlined
        :disabled="loading"
        :rules="[(v) => publicKeyRegex.test(v) || 'Chave Pública inválida']"
      />

      <v-alert v-if="error" type="error" text>
        {{ error }}
      </v-alert>

      <v-alert type="info" text>
        Não será verificado se os dados estão corretos. Confira os dados antes
        de salvar.
      </v-alert>

      <v-btn
        color="primary"
        @click="save"
        :disabled="!valid"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "PagseguroSettings",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    gateways: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      valid: false,
      loading: false,
      token: "",
      publicKey: "",
      secretRegex: /^sk_[a-zA-Z0-9]{32,64}$/,
      publicKeyRegex: /^pk_[a-zA-Z0-9]{16,20}$/,
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        this.error = null;
        const response = await platformService.updateGateway(
          this.platform.id,
          "pagarme",
          {
            secret: this.secret,
            publicKey: this.publicKey,
          }
        );

        const publicKey = response.data.find(
          (item) => item.key === "publicKey"
        );
        if (publicKey) this.publicKey = publicKey.value;

        this.$emit("update:valid", true);
      } catch (error) {
        this.error = error.message || "Erro ao salvar configurações";
        this.$emit("update:valid", false);
      } finally {
        this.loading = false;
      }
    },
    load() {
      this.secret = this.gateways.pagarme.secret;
      this.publicKey = this.gateways.pagarme.publicKey;
      this.$emit("update:valid", !!this.gateways.pagarme.publicKey);
    },
  },
  watch: {
    token: {
      handler(val, oldVal) {
        if (!oldVal) return;
        this.publicKey = "";
        this.$emit("update:valid", false);
      },
    },
    gateways: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
};
</script>
